import { Component, Input } from '@angular/core';
import { MatTooltipModule } from '@angular/material/tooltip';
import { CommonModule } from '@angular/common';

@Component({
  selector: 'app-custom-tooltip',
  standalone: true,
  imports: [CommonModule, MatTooltipModule],
  templateUrl: './custom-tooltip.html',
  styleUrls: ['./custom-tooltip.css']
})
export class CustomTooltipComponent {
  @Input() text: string | null = '';

  @Input() position: 'above' | 'below' | 'left' | 'right' = 'above';
}
